import { render, staticRenderFns } from "./monitor-haikang.vue?vue&type=template&id=406fe2c8&scoped=true&"
import script from "./monitor-haikang.vue?vue&type=script&lang=js&"
export * from "./monitor-haikang.vue?vue&type=script&lang=js&"
import style0 from "./monitor-haikang.vue?vue&type=style&index=0&id=406fe2c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406fe2c8",
  null
  
)

export default component.exports